import {ButtonIconTooltip, CheckIcon, CloseIcon, HStack} from "@hosttools/frontend";
import type React from "react";
import {memo} from "react";

type Props = {
    onSubmit: () => void;
    onCancel: () => void;
};

const RowAction: React.FC<Props> = ({onSubmit, onCancel}) => {
    return (
        <HStack className="items-center justify-end" space="xs">
            <ButtonIconTooltip
                action="primary"
                icon={CheckIcon}
                tooltip="Save"
                onPress={onSubmit}
            />
            <ButtonIconTooltip
                action="negative"
                icon={CloseIcon}
                tooltip="Cancel"
                onPress={onCancel}
            />
        </HStack>
    );
};

export default memo(RowAction);
